import React from 'react';

const Loader = () => {
    return (
        <div className='text-center text-3xl'> <h2>Loading...</h2> <span className="loading loading-dots loading-lg bg-primary"></span></div>
    );
};

export default Loader;
